module.exports = __webpack_public_path__ + "img/ondulacao.866bebed.svg";